import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { XMLParser } from 'fast-xml-parser';

import './Home.sass';

function Home({navOptionClicked}) {
  const band = require('../assets/band_banner.jpg');

  const feed = 'https%3A%2F%2Fbealtaine.substack.com%2Ffeed';
  const corsProxy = 'https://api.rss2json.com/v1/api.json?rss_url=' + feed;
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(corsProxy)
      .then(result => result.json())
      .then(data => {
        console.log(data);
        setPosts(data.items);
        setLoading(false);
      })
      .catch(error => console.error(error));
  }, []);

  return (
    <div className="HomePane">
      <img alt="Members of the band" src={band} />
      <div className="MobileLinks Celtic">
        <Link to="/Shows" onClick={() => navOptionClicked("Shows")}>Shows</Link>
        <Link to="/Contact" onClick={() => navOptionClicked("Contact")}>Follow Us</Link>
      </div>
      {loading && <div className="loader"></div>}
      {posts && posts.length && !loading &&
      <div className="SubstackPane">
        {posts.map((post, index) => (
          <div key={index} className="Post" style={{animationDelay: (index * 0.1) + 's'}}>
            <h3>{post.title}</h3>
            <div dangerouslySetInnerHTML={{__html: post.content}}></div>
          </div>
        ))}
      </div>}
    </div>
  );
}

export default Home;
